import React, { useState, useEffect, useRef, useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { CardBody, Col, Container, Row } from "reactstrap";
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { ReportSourceApi } from 'utils/ApiClients';
import axios from 'axios';
import CompanySelector from 'ATSComponents/Common/CompanySelector';
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer";
import { set } from 'lodash';

const SourcePerformanceReport = () => {
    const [sourceData, setSourceData] = useState([]);
    const [sourceTypes, setSourceTypes] = useState([]);
    const [selectedSourceData, setSelectedSourceData] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [loading, setLoading] = useState(true);
    document.title = "ATS - Reports"
    const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
    const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);

    const handleCompanyChange = (company) => {
        if (company?.company_id) {
            const selectedId = company.company_id;
            setCompanyId(selectedId);

            // fetchSourceTypes(selectedId);
            // fetchSourceData(selectedId);
        }
    };



   // Update filters state to include new fields
// const [filters, setFilters] = useState({
//     global: { value: null, matchMode: FilterMatchMode.CONTAINS },
//     source_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
//     candidate_id: { value: null, matchMode: FilterMatchMode.EQUALS },
//     first_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
//     email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
//     status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
//     job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH }, // Add job_title
//     received: { value: null, matchMode: FilterMatchMode.STARTS_WITH }, // Add received
//     potential_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH }, // Add potential_date
//     interview_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH }, // Add interview_date
//     offer_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH }, // Add offer_date
//     joining_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH }, // Add joining_date
//     closure_duration_days: { value: null, matchMode: FilterMatchMode.EQUALS } // Add closure_duration_days
// });
const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    source_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    candidate_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    received: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    potential_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    interview_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    offer_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    joining_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    closure_duration_days: { value: null, matchMode: FilterMatchMode.EQUALS },
    placement_status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    candidate_email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
});
    const dt = useRef(null);

    // Fetch candidates data// Fetch candidates data

     const fetchSourceData = async (companyId) => {
        setLoading(true);
        try {
            const response = await ReportSourceApi(`/source_performance_report/?company_id=${companyId}`);
            if (response?.data) {
                const flatData = response.data.flatMap(source => {
                    if (source.candidates.length > 0) {
                        return source.candidates.map(candidate => ({
                            ...candidate,
                            source_name: source.source_name,
                        }));
                    } else {
                        return [{
                            candidate_id: '',
                            first_name: '',
                            candidate_email: '',
                            status: '',
                            source_name: source.source_name,
                            isEmptyRow: true
                        }];
                    }
                });
                setSourceData(flatData);
                setLoading(false);
            }
        } catch (error) {
            console.error("Failed to fetch source performance report:", error);
            setLoading(false);
        }
    };

    const fetchSourceTypes = async (companyId) => {
        try {
            const response = await axios.get(`/api/v1/get-all-resume-source-types/?company_id=${companyId}`);
            setSourceTypes(response?.data?.results || []);
        } catch (error) {
            console.error("Failed to fetch source types:", error);
        }
    };

    useEffect(() => {
        if (companyId) {
            fetchSourceData(companyId);
        }
    }, [companyId]);

    useEffect(() => {
        if (companyId) {
            fetchSourceTypes(companyId);
        }
    }, [companyId]);


// useEffect(() => {
//     const fetchSourceData = async () => {
//         try {
//             const response = await ReportSourceApi('/source_performance_report/');
//             if (response?.data) {
//                 const flatData = response.data.flatMap(source => {
//                     if (source.candidates.length > 0) {
//                         return source.candidates.map(candidate => ({
//                             ...candidate,
//                             source_name: source.source_name,
//                         }));
//                     } else {
//                         return [{
//                             candidate_id: '',
//                             first_name: '',
//                             candidate_email: '',
//                             status: '',
//                             source_name: source.source_name,
//                             isEmptyRow: true
//                         }];
//                     }
//                 });
//                 setSourceData(flatData);
//             }
//         } catch (error) {
//             console.error("Failed to fetch source performance report:", error);
//         }
//     };
//     fetchSourceData();
// }, []);

    // Fetch source types metadata (including icons)
    // useEffect(() => {
    //     const fetchSourceTypes = async () => {
    //         try {
    //             const response = await axios.get('/api/v1/get-all-resume-source-types/');
    //             setSourceTypes(response?.data?.results || []);
    //         } catch (error) {
    //             console.error("Failed to fetch source types:", error);
    //         }
    //     };
    //     fetchSourceTypes();
    // }, []);

    // Map resume_source to the type object
    const sourceTypeMap = useMemo(() => {
        return sourceTypes.reduce((acc, type) => {
            acc[type.resume_source] = type;
            return acc;
        }, {});
    }, [sourceTypes]);

    // Count candidates per source
    const calculateTotalCandidates = (source) => {
        return sourceData.filter(entry => entry.source_name === source && !entry.isEmptyRow).length;
    };

    // Header with icons and count
   const headerTemplate = (data) => {
    const typeInfo = sourceTypeMap[data.source_name];
    const iconSrc = typeInfo?.icon || '';

    return (
        <React.Fragment>
            <span className="font-bold line-height-3 gap-2">
                {iconSrc && (
                    <img
                        src={iconSrc}
                        alt={`${data.source_name} icon`}
                        style={{
                            width:"30px",
                            height:"30px",
                            verticalAlign: 'middle', 
                            marginRight:'10px',
                            borderRadius: '50%',
                        }}
                    />
                )}
                {data.source_name}
            </span>

            <span className="font-bold line-height-3 float-end me-4">
                Total Candidates: {calculateTotalCandidates(data.source_name)}
            </span>
        </React.Fragment>
    );
};

const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
};

    const emptyCellTemplate = (field) => (rowData) => {
        return rowData.isEmptyRow ? <i>-</i> : rowData[field] ?? '-';
    };

    // Export & print utility functions (unchanged)
    const exportCSV = (selectionOnly) => {
        if (selectionOnly && selectedSourceData.length > 0) {
            dt.current.exportCSV({ selectionOnly: true });
        } else {
            dt.current.exportCSV({ selectionOnly: false });
        }
    };
const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
        import("jspdf-autotable").then(() => {
            const doc = new jsPDF.default("landscape");
            const dataToExport = selectedSourceData.length > 0 ? selectedSourceData : sourceData;
            const filteredData = dataToExport.filter(row => !row.isEmptyRow);
            const exportColumns = [
                { title: "Source Name", dataKey: "source_name" },
                { title: "First Name", dataKey: "first_name" },
                { title: "Email", dataKey: "candidate_email" },
                { title: "Status", dataKey: "status" },
            ];
            const formattedData = filteredData.map(item => {
                const row = {};
                exportColumns.forEach(col => {
                    row[col.dataKey] = item[col.dataKey] ?? '';
                });
                return row;
            });
            doc.autoTable({
                columns: exportColumns,
                body: formattedData.length > 0 ? formattedData : [{ message: "No data to export" }],
                startY: 20,
                styles: { fontSize: 8, cellPadding: 2 },
                theme: "grid",
                margin: { top: 10, left: 5, right: 5 },
                columnStyles: { 0: { cellWidth: 30 } },
            });
            doc.save("source_performance_report.pdf");
        });
    });
};

const exportExcel = () => {
    import('xlsx').then(xlsx => {
        const dataToExport = selectedSourceData.length > 0 ? selectedSourceData : sourceData;
        const filteredData = dataToExport.filter(row => !row.isEmptyRow);
        const worksheet = xlsx.utils.json_to_sheet(
            filteredData.length > 0 ? filteredData : [{ message: "No data to export" }],
            { header: ['source_name', 'candidate_id', 'first_name', 'candidate_email', 'status'] }
        );
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });
        saveAsExcelFile(excelBuffer, 'source_performance_report');
    });
};

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module?.default) {
                const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], { type: EXCEL_TYPE });
                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };

const printFile = () => {
    const dataToPrint = selectedSourceData.length > 0 ? selectedSourceData : sourceData;
    const filteredData = dataToPrint.filter(row => !row.isEmptyRow);
    const exportColumns = [
        { title: "Source Name", dataKey: "source_name" },
        { title: "Candidate ID", dataKey: "candidate_id" },
        { title: "First Name", dataKey: "first_name" },
        { title: "Email", dataKey: "candidate_email" },
        { title: "Status", dataKey: "status" },
    ];
    const tableHeaders = exportColumns
        .map(col => `<th style="border: 1px solid #ccc; padding: 8px;">${col.title}</th>`).join('');
    const tableRows = filteredData.length > 0
        ? filteredData.map(row => {
            return `<tr>${exportColumns
                .map(col => `<td style="border: 1px solid #ccc; padding: 8px;">${row[col.dataKey] ?? ''}</td>`).join('')}</tr>`;
        }).join('')
        : `<tr><td colspan="${exportColumns.length}" style="border: 1px solid #ccc; padding: 8px; text-align: center;">No data to print</td></tr>`;

    const htmlContent = `
        <html>
        <head><title>Print Source Performance Report</title>
        <style>
            table {border-collapse: collapse;width: 100%;margin-top: 20px;}
            th, td {border: 1px solid #ccc; padding: 8px; text-align: left;}
            h2 {text-align: center;}
        </style></head>
        <body><h2>Source Performance Report</h2>
        <table><thead><tr>${tableHeaders}</tr></thead><tbody>${tableRows}</tbody></table>
        </body></html>`;

    const printWindow = window.open('', '', 'height=600,width=900');
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
};

    return (
    <div className="page-content allact-tabs">
        <Container fluid={true}>
            <div className="page-title-box actjobbread">
                <Row className="align-items-center actjobsum">
                    <Col sm={6} md={6} lg={8}>
                        <h1 className="page-title">Source Performance Report</h1>
                    </Col>
                    <Col sm={6} md={6} lg={4}>
                        <div className="allbtns d-flex gap-2 justify-content-end">
                            <Button icon="pi pi-file" rounded onClick={() => exportCSV(true)} tooltip="Export to CSV" tooltipOptions={{ position: "left" }} className="csvbtn" />
                            <Button icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} tooltip="Export to XLS" tooltipOptions={{ position: "top" }} className="xlsbtn" />
                            <Button icon="pi pi-file-pdf" severity="warning" rounded onClick={exportPdf} tooltip="Export to PDF" tooltipOptions={{ position: "bottom" }} className="pdfbtn" />
                            <Button icon="pi pi-print" severity="warning" rounded tooltip="Print" tooltipOptions={{ position: "bottom" }} className="printbtn" onClick={printFile} />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xxl={6}>
                        <h1 className="page-title mb-4"> </h1>
                    </Col>
                    <Col xxl={6}>
                        <div className="d-flex justify-content-end mt-2">
                            <label className="mt-2 me-2">Select Company</label>
                            <div className="mb-2 me-2" style={{ width: "170px" }}>
                                <CompanySelector onCompanyChange={handleCompanyChange} />
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row><Col lg={12}>
                    <div className="page-title-box actjobsumtable mb-0">
                        {loading ? (
                            <OrgTableShimmer columns={6} rows={7} titleWidth="220px" />
                        ) : (

                            <DataTable
        ref={dt}
        value={sourceData}
        rowGroupMode="subheader"
        groupRowsBy="source_name"
        expandableRowGroups
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowGroupHeaderTemplate={headerTemplate}
        tableStyle={{ minWidth: '70rem' }}
        selectionMode="multiple"
        selection={selectedSourceData}
        onSelectionChange={(e) => setSelectedSourceData(e.value)}
        filters={filters}
        filterDisplay="row"
        globalFilterFields={[
            'source_name', 'candidate_name', 'job_id', 'job_title', 'received',
            'potential_date', 'interview_date', 'offer_date', 'joining_date',
            'closure_duration_days', 'placement_status', 'status', 'candidate_email'
        ]}
    >
        <Column field="source_name" header="Source Name" body={emptyCellTemplate('source_name')} filter filterPlaceholder="Search Source Name" style={{ minWidth: '10rem' }} />
        <Column field="candidate_name" header="Candidate Name" body={emptyCellTemplate('candidate_name')} filter filterPlaceholder="Search Candidate Name" style={{ minWidth: '10rem' }} />
        <Column field="job_id" header="Job ID" body={emptyCellTemplate('job_id')} filter filterPlaceholder="Search Job ID" style={{ minWidth: '8rem' }} />
        <Column field="job_title" header="Job Title" body={emptyCellTemplate('job_title')} filter filterPlaceholder="Search Job Title" style={{ minWidth: '12rem' }} />
    <Column field="received" header="Received" 
        body={rowData => rowData.isEmptyRow ? <i>-</i> : formatDate(rowData.received)} 
        filter filterPlaceholder="Search Received" style={{ minWidth: '10rem' }} />
    <Column field="potential_date" header="Potential Date" 
        body={rowData => rowData.isEmptyRow ? <i>-</i> : formatDate(rowData.potential_date)} 
        filter filterPlaceholder="Search Potential Date" style={{ minWidth: '10rem' }} />
    <Column field="interview_date" header="Interview Date" 
        body={rowData => rowData.isEmptyRow ? <i>-</i> : formatDate(rowData.interview_date)} 
        filter filterPlaceholder="Search Interview Date" style={{ minWidth: '10rem' }} />
    <Column field="offer_date" header="Offer Date" 
        body={rowData => rowData.isEmptyRow ? <i>-</i> : formatDate(rowData.offer_date)} 
        filter filterPlaceholder="Search Offer Date" style={{ minWidth: '10rem' }} />
    <Column field="joining_date" header="Joining Date" 
        body={rowData => rowData.isEmptyRow ? <i>-</i> : formatDate(rowData.joining_date)} 
        filter filterPlaceholder="Search Joining Date" style={{ minWidth: '10rem' }} />
    <Column field="closure_duration_days" header="Closure Duration (Days)" 
        body={rowData => rowData.isEmptyRow ? <i>-</i> : rowData.closure_duration_days ?? ''} 
        filter filterPlaceholder="Search Closure Duration" style={{ minWidth: '8rem' }} />
    <Column field="placement_status" header="Placement Status" 
        body={rowData => rowData.isEmptyRow ? <i>-</i> : rowData.placement_status ?? ''} 
        filter filterPlaceholder="Search Placement Status" style={{ minWidth: '10rem' }} />
        <Column field="status" header="Status" body={emptyCellTemplate('status')} filter filterPlaceholder="Search Status" style={{ minWidth: '10rem' }} />
        <Column field="candidate_email" header="Email" body={emptyCellTemplate('candidate_email')} filter filterPlaceholder="Search Email" style={{ minWidth: '10rem' }} />
                            </DataTable>
                        )}

                    </div>
                </Col></Row>
            </div>
        </Container>
    </div>
);
};

export default SourcePerformanceReport;
